export default "__VITE_ASSET__0733cd58__"